import { useTran } from "@/hooks";
import { Badge } from "@/components/ui/badge";

/**
 * MetricCardFooter - Displays framework and parent code
 */
const MetricCardFooter = ({ disclosure }) => {
  const { t } = useTran();

  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground">
      <Badge variant="outline" className="text-xs">
        {disclosure.framework}
      </Badge>
      {disclosure.parentCode ? (
        <span>
          {t("Parent")}: {disclosure.parentCode}
        </span>
      ) : null}
    </div>
  );
};

export default MetricCardFooter;
